import classNames from 'classnames';
import { debounce } from 'lodash';
import React, { useState } from 'react';
import { SettingsMobileHeader, ModalCloseButton, TextSearchInput } from 'wix-rich-content-ui-components';
import { s as styleInject } from './style-inject.es-e7b07dd7.js';
import { UPLOAD_MODAL, UPLOAD_MODAL_INPUT } from './dataHooks.js';
import GiphySelector from './toolbar/giphySelector.js';

var css_248z = ".t21wY._2QSe9{box-sizing:border-box;overflow:hidden;position:absolute;top:50px;width:100%}[dir] .t21wY._2QSe9{padding:12px 20px}.t21wY._2QSe9 *,.t21wY._2QSe9 :after,.t21wY._2QSe9 :before{box-sizing:inherit}.t21wY._2QSe9 input{box-sizing:border-box}.Zt1ro{display:flex;font-size:16px;justify-content:space-between;line-height:1.5}[dir] .Zt1ro{margin-bottom:20px}.VeUXo{display:grid;grid-template-areas:\"title icon\"}[dir] .VeUXo{padding-top:15px}[dir=ltr] .VeUXo{padding-left:20px}[dir=rtl] .VeUXo{padding-right:20px}.i1oJF{display:flex;grid-area:icon;justify-self:end}[dir=ltr] .i1oJF{padding-right:20px}[dir=rtl] .i1oJF{padding-left:20px}@supports not (contain:inline-size){@media only screen and (min-width:940px){.kdGwC{width:280px}}}@container (min-width: 940px){.kdGwC{width:280px}}";
var styles = {"giphy_api_input_modal_container":"t21wY","mobile":"_2QSe9","giphy_modal_header_container":"Zt1ro","giphy_api_input_modal_navbar":"VeUXo","giphy_api_input_modal_closeButton":"i1oJF","modalWrapper":"kdGwC"};
styleInject(css_248z);

const GiphyApiInputModal = ({
  onGifAdd,
  componentData,
  helpers,
  languageDir,
  onCloseRequested,
  showCloseButton,
  t,
  getGiphyUrl,
  isMobile
}) => {
  const [searchTag, setSearchTag] = useState("");
  const triggerBi = debounce(() => {
    helpers.onPluginAction(searchTag);
  });
  const onChange = (searchTag2) => {
    setSearchTag(searchTag2);
    triggerBi();
  };
  return /* @__PURE__ */ React.createElement("div", { dir: languageDir, className: isMobile ? styles.gif_modal_mobile_container : void 0 }, isMobile && /* @__PURE__ */ React.createElement(
    SettingsMobileHeader,
    {
      onCancel: onCloseRequested,
      t,
      title: t("GIFPlugin_Mobile_Header"),
      showSaveBtn: false
    }
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(styles.giphy_api_input_modal_container, {
        [styles.mobile]: isMobile
      }),
      "data-hook": UPLOAD_MODAL
    },
    showCloseButton && /* @__PURE__ */ React.createElement("div", { className: styles.giphy_modal_header_container }, /* @__PURE__ */ React.createElement("div", null, t("Giphy_Modal_Header_Title")), /* @__PURE__ */ React.createElement(ModalCloseButton, { closeModal: onCloseRequested })),
    /* @__PURE__ */ React.createElement(
      TextSearchInput,
      {
        onClose: onCloseRequested,
        placeHolder: t("GiphyUploadModal_Search_Placeholder"),
        onChange,
        value: searchTag,
        "data-hook": UPLOAD_MODAL_INPUT
      }
    ),
    /* @__PURE__ */ React.createElement(
      GiphySelector,
      {
        searchTag,
        onCloseRequested,
        onGifAdd,
        getGiphyUrl,
        t,
        componentData
      }
    )
  ));
};

export { GiphyApiInputModal as G, styles as s };
//# sourceMappingURL=giphyApiInputModal-d85ca8e9.js.map
